module.exports = __webpack_public_path__ + "img/Project-2.86bc5c2.jpg";